<template>
  <div class="institutional">
    <Header />
    <div class="content">
      <div class="bg">
        <div class="title">
          <span class="zn">机构动态</span>
          <span class="en">Agency dynamics</span>
          <span class="line"></span>
          <span>{{ AgencyCompany }}</span>
        </div>
      </div>
      <ul class="list">
        <li v-for="(item,index) in newsList" :key="index">
          <div class="details">
            <h3 @click="toDynamicsDetails(item.InfoID)" :style="{ cursor: 'pointer' }">{{ item.Title }}</h3>
            <div class="text">{{ item.Introduction }}</div>
            <div class="from">
              <span>来源：{{ item.InfoSource }}</span>
              <span>日期：{{ item.CreateTime }}</span>
            </div>
          </div>
        </li>
      </ul>
      <el-pagination background layout="total,prev,pager,next,jumper" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-size="pageSize" :total="totalCount" />
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from './components/Header'
import Footer from './components/Footer'
import { GetPage } from './utils/http'
export default {
  name: 'InstitutionalDynamics',
  components: { Header, Footer },
  data() {
    return {
      newsList: [],
      type: 1, //动态类型 1众信动态 2行业资讯
      AgencyCompany: '众信动态',
      totalCount: 0,
      pageSize: 5,
      currentPage: 1
    }
  },
  created() {
    const currentPage = this.$route.params.currentPage
    this.handleCurrentChange(currentPage || this.currentPage)
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this.getNewsList()
    },
    getNewsList() {
      GetPage(this.type, this.currentPage).then(res => {
        const { status, data } = res
        if (status == 200) {
          this.newsList = data.InfoRelModel.map(item => {
            if(item.Introduction) {
              item.Introduction = item.Introduction.length > 140 ? `${ item.Introduction.substring(0,140) }...` : item.Introduction
            }
            return item
          })
          this.totalCount = +data.totalCount
        }
      }).catch(err => { console.log(err) })
    },
    toDynamicsDetails(newsId) {
      this.$router.push({ name: 'DynamicsDetails', params: { newsId, currentPage: this.currentPage } })
    }
  }
};
</script>
<style lang="less" scoped>
.institutional {
  .content {
    margin-top: 60px;
    .bg {
      width: 100%;
      height: 200px;
      background: url(./assets/images/banner/banner2.png) no-repeat;
      .title {
        width: 1040px;
        margin: 0 auto;
        padding-top: 80px;
        span {
          color: #2d313d;
          &.zn {
            font-size: 24px;
            font-weight: bold;
            margin-right: 20px;
          }
          &.en {
            font-size: 24px;
          }
          &.line {
            display: block;
            width: 22px;
            height: 8px;
            margin: 13px 0 20px;
            background-color: #d0211f;
          }
        }
      }
    }
    .list {
      width: 1040px;
      margin: 40px auto;
      li {
        padding: 20px;
        border-bottom: 1px solid #eee;
        img {
          display: inline-block;
          width: 215px;
          vertical-align: top;
          margin-right: 20px;
        }
        .details {
          display: inline-block;
          width: 100%;
        }
        h3 {
          font-size: 18px;
          color: #333;
          margin-bottom: 20px;
          &:hover{
            color: #d0211f;
          }
        }
        .text {
          font-size: 14px;
          color: #666;
          width: 780px;
        }
        .from {
          font-size: 14px;
          color: #999;
          margin-top: 18px;
          span{
            margin-right: 20px;
          }
        }
      }
    }
    /deep/ .el-pagination {
      width: 1040px;
      text-align: center;
      margin: 35px auto;
    }
  }
}
</style>